import React, {
  useCallback,
  useState,
  useContext,
  createContext,
  useMemo,
} from 'react';

const ModalFuncaoContext = createContext({});

export function ModalFuncaoProvider({ children }) {
  const [showModalFuncao, setShowModalFuncao] = useState(false);

  const openModalFuncao = useCallback(() => {
    setShowModalFuncao(true);
  }, []);

  const closeModalFuncao = useCallback(() => {
    setShowModalFuncao(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      showModalFuncao,
      openModalFuncao,
      closeModalFuncao,
    }),
    [showModalFuncao, openModalFuncao, closeModalFuncao],
  );

  return (
    <ModalFuncaoContext.Provider value={contextValue}>
      {children}
    </ModalFuncaoContext.Provider>
  );
}

export function useModalFuncao() {
  const context = useContext(ModalFuncaoContext);

  if (!context)
    throw new Error('useModalFuncao must be used within a ModalFuncaoProvider');

  return context;
}
